/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptUserInviteDTO
 */
export interface AcceptUserInviteDTO {
    /**
     * 
     * @type {string}
     * @memberof AcceptUserInviteDTO
     */
    token: string;
}

/**
 * Check if a given object implements the AcceptUserInviteDTO interface.
 */
export function instanceOfAcceptUserInviteDTO(value: object): value is AcceptUserInviteDTO {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function AcceptUserInviteDTOFromJSON(json: any): AcceptUserInviteDTO {
    return AcceptUserInviteDTOFromJSONTyped(json, false);
}

export function AcceptUserInviteDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptUserInviteDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function AcceptUserInviteDTOToJSON(value?: AcceptUserInviteDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

